import React from "react";
import { Radio, Clock, Sparkles } from "lucide-react";

export default function Step1Welcome({ firstName, onStart, onSkipAll, busy }) {
  return (
    <div className="text-center py-6" data-testid="onboarding-step1">
      <div className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-brand-amber/15 border border-brand-amber/30 mb-6">
        <Radio className="h-8 w-8 text-brand-amber" />
      </div>
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-amber mb-3">// Welcome aboard</div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-ink-primary mb-3">
        Welcome to BroadcastFlow AI{firstName ? `, ${firstName}` : ""}
      </h1>
      <p className="text-sm sm:text-base text-ink-secondary max-w-md mx-auto mb-6">
        Let's set up your radio station, connect your tools, and prepare your first AI-powered broadcast workflow.
      </p>
      <div className="inline-flex items-center gap-2 rounded-full border border-line bg-bg-elevated px-4 py-1.5 text-xs text-ink-secondary mb-8">
        <Clock className="h-3.5 w-3.5 text-brand-amber" /> Estimated setup time: about 10 minutes
      </div>
      <div className="flex flex-col items-center gap-3">
        <button type="button" onClick={onStart} disabled={busy} data-testid="onboarding-start-btn"
          className="inline-flex items-center gap-2 rounded-md bg-brand-amber px-8 py-3 text-sm font-semibold text-black hover:bg-brand-amber/90 transition disabled:opacity-50">
          <Sparkles className="h-4 w-4" /> Start Setup
        </button>
        <button type="button" onClick={onSkipAll} disabled={busy} data-testid="onboarding-skip-all-btn"
          className="text-sm text-ink-muted hover:text-ink-primary transition">
          Skip for Now
        </button>
      </div>
    </div>
  );
}
